module.exports = __webpack_public_path__ + "2353007536782f24b0d26c2746816fb3.svg";